<template>
  <div class="main-content">

    <!-- Login Start-->
    <section class="login-form section m-0 pb-0">

      <!-- MFA Verify Container -->
      <div class="container-fluid p-0">
        <div class="login-container">
          <div :class="contentClass">
            <div :style="{ minHeight: `${loginContainerHeight}px`, }" class="content row mx-0 form-fields d-flex justify-content-center text-display">
              <div class="col-12 col-lg-4 col-xl-4 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-center">
                <div class="title-defined h-auto d-flex flex-column justify-content-center align-items-center align-items-lg-start align-items-xl-start mb-5">
                  <div class="w-100 h-auto title-text text-center text-lg-left text-xl-left">
                    Verify Email
                  </div>
                  <div class="description-text text-center text-lg-left text-xl-left px-4 px-md-0 px-lg-0 px-xl-0" v-html="`We sent a verification code to ${email}. Please check your inbox and enter the six digit code to verify your account.`">
                  </div>
                </div>
              </div>
              
              <div :class="inputEntryClass" class="col-12 col-lg-8 col-xl-8 p-0 pl-0 pl-lg-5 pl-xl-5 border-class d-flex flex-column justify-content-center align-items-center align-items-lg-start align-items-xl-start verification-code">
                <div class="w-auto d-flex flex-column align-items-center align-items-md-start align-items-lg-start align-items-xl-start">
                  <p class="verification-text m-0">
                    Verification Code
                  </p>
                  <img 
                    style="width: 57%;"
                    :src="require('@assetsImages/icon-image/verification.svg')" 
                    alt="Email Verification"
                  >
                </div>

                <div class="container-fluid p-0 m-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                  <div class="row m-0 h-100 input-code-row">
                    <!-- Resend Code-Digit 1 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode1"
                          v-model="codeEntry1"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>

                    <!-- Resend Code-Digit 2 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode2"
                          v-model="codeEntry2"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>

                    <!-- Resend Code-Digit 3 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode3"
                          v-model="codeEntry3"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>

                    <!-- Resend Code-Digit 4 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode4"
                          v-model="codeEntry4"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>

                    <!-- Resend Code-Digit 5 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode5"
                          v-model="codeEntry5"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>

                    <!-- Resend Code-Digit 6 -->
                    <div class="col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                      <div class="input-code-container">
                        <input 
                          type="number" 
                          class="input-code"
                          ref="inputCode6"
                          v-model="codeEntry6"
                          @keypress="inputCodeEntry"
                          @input="inputCodeEntry"
                          @paste="pasteCodeEntry"
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-auto">
                  <a href="#" @click.prevent="sendEmailVerificationCode">
                    <span class="resend-code-link" :style="{ color: (isResendCodeLinkInactive || verified) ? '#696969' : primaryWhiteColor }">
                      {{ (isResendCodeLinkInactive && !verified) ? `Resend Code (${resendCodeTimeInterval}s)` : `Resend Code` }}
                    </span>
                  </a>
                </div>

                <div class="d-flex flex-column flex-lg-row flex-xl-row justify-content-center justify-content-lg-start justify-content-xl-start item-btn-gap">
                  <b-button
                    class="item-btn"
                    size="sm"
                    :disabled="verified || code.length !== 6"
                    @click="submit"
                  >
                    Submit Code
                  </b-button>

                  <router-link
                    :to="{
                      name: 'login',
                    }"
                    >
                    <b-button
                      class="item-btn"
                      size="sm"
                      @click="''"
                      >Back To Login
                    </b-button>
                  </router-link>
                </div>

                <div style="height: 20px;" class="container-fluid p-0 m-0">
                  <div class="row m-0 h-100">
                    <div 
                      v-if="hasResponseError || isCodeResent" 
                      style="font-size: 16px; font-family: Rajdhani;" 
                      class="col-12 p-0 m-0 text-center text-lg-left text-xl-left"
                    >
                      <strong v-if="isCodeResent" :style="{ color: primaryWhiteColor }" class="m-0">
                        {{ successMessage }}
                      </strong>
                      <strong v-else :style="{ color: invalidFormLabelColor, }">
                        {{ resendCodeErrorMsg }}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Login End -->
  </div>
</template>
<script>
import axios from "axios"

function computeLoginContainerHandler() {
  const navHeight = document.querySelector('nav').clientHeight;
  const footerHeight = document.querySelector('.v-footer').clientHeight;
  const windowHeight = window.innerHeight + 100;

  this.loginContainerHeight = windowHeight - footerHeight - navHeight;
};

export default {
  name: "verify",
  props: {
    email: {
      type: String,
      default: "test@gmail.com",
    }, 
    message: String, 
    accountType: String, 
    redirect: String,
  },
  data() {
    return {
      busy: false,
      verified: false,
      isCodeResent: false,
      successMessage: "",
      hasResponseError: false,
      resendCodeErrorMsg: null,
      resendCodeTimeInterval: 60,
      isResendCodeLinkInactive: false,
      loginContainerHeight: null,
      codeEntry1: "",
      codeEntry2: "",
      codeEntry3: "",
      codeEntry4: "",
      codeEntry5: "",
      codeEntry6: "",
      code: "",
    }
  },
  computed: {
    contentClass() {
      return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? "mobile-content" : "desktop-content";
    },
    inputEntryClass() {
      if(this.$vuetify.breakpoint.xs) {
        return "input-entry-xs-class";
      }
      else if(this.$vuetify.breakpoint.sm) {
        return "input-entry-sm-class";
      }
      else if(this.$vuetify.breakpoint.md) {
        return "input-entry-md-class";
      }
      else {
        return "input-entry-class";
      }
    }
  },
  mounted() {
    this.init()
  },
  destroyed() {
    window.removeEventListener('resize', computeLoginContainerHandler.bind(this));
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();

      computeLoginContainerHandler.call(this);
      window.addEventListener('resize', computeLoginContainerHandler.bind(this));

      this.startCountDownTimer();
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight()
      $(".main-content").css("margin-bottom", footerHeight)
    },
    startCountDownTimer() {
      this.isResendCodeLinkInactive = true;

      const timerInterval = setInterval(() => {
        if(this.resendCodeTimeInterval === 1) {
          clearInterval(timerInterval);

          this.resendCodeTimeInterval = 60;
          this.isResendCodeLinkInactive = false;
          this.isCodeResent = false;

          return;
        }

        this.resendCodeTimeInterval -= 1;
      }, 1000);
    },
    pasteCodeEntry(event) {
      setTimeout(() => {
        const { value } = event.srcElement;
        const codeValue = value.split("");

        // First Code Entry Digit After Pasting CodeEntry
        this.codeEntry1 = codeValue[0];
        this.$refs.inputCode1.value = codeValue[0];
        this.$refs.inputCode1.blur();

        // Second Code Entry Digit After Pasting CodeEntry
        this.codeEntry2 = codeValue[1];
        this.$refs.inputCode2.value = codeValue[1];
        this.$refs.inputCode2.blur();

        // Third Code Entry Digit After Pasting CodeEntry
        this.codeEntry3 = codeValue[2];
        this.$refs.inputCode3.value = codeValue[2];
        this.$refs.inputCode3.blur();

        // Fourth Code Entry Digit After Pasting CodeEntry
        this.codeEntry4 = codeValue[3];
        this.$refs.inputCode4.value = codeValue[3];
        this.$refs.inputCode4.blur();

        // Fifth Code Entry Digit After Pasting CodeEntry
        this.codeEntry5 = codeValue[4];
        this.$refs.inputCode5.value = codeValue[4];
        this.$refs.inputCode5.blur();

        // Sixth Code Entry Digit After Pasting CodeEntry
        this.codeEntry6 = codeValue[5];
        this.$refs.inputCode6.value = codeValue[5];
        this.$refs.inputCode6.blur();

        // The code verification consisting of the code-digit entries
        this.code = [
          this.codeEntry1, 
          this.codeEntry2, 
          this.codeEntry3, 
          this.codeEntry4, 
          this.codeEntry5, 
          this.codeEntry6,
        ].join("");
      }, 0);
    },
    inputCodeEntry(event) {
      const { type, srcElement } = event;

      const updateCodeDigitEntry = (vmodel, type, srcElement) => {
        if(type === 'keypress') {
          this[vmodel] = "";
          return;
        };

        srcElement.value = this[vmodel];

        switch(vmodel) {
          case "codeEntry1":
            this.$refs.inputCode2.focus();
            break;
          case "codeEntry2":
            this.$refs.inputCode3.focus();
            break;
          case "codeEntry3":
            this.$refs.inputCode4.focus();
            break;
          case "codeEntry4":
            this.$refs.inputCode5.focus();
            break;
          case "codeEntry5":
            this.$refs.inputCode6.focus();
            break;
          default:
            this.$refs.inputCode6.blur();
        }
      };

      if(srcElement === this.$refs.inputCode1) {
        updateCodeDigitEntry("codeEntry1", type, srcElement);
      }
      else if(srcElement === this.$refs.inputCode2) {
        updateCodeDigitEntry("codeEntry2", type, srcElement);
      }
      else if(srcElement === this.$refs.inputCode3) {
        updateCodeDigitEntry("codeEntry3", type, srcElement);
      }
      else if(srcElement === this.$refs.inputCode4) {
        updateCodeDigitEntry("codeEntry4", type, srcElement);
      }
      else if(srcElement === this.$refs.inputCode5) {
        updateCodeDigitEntry("codeEntry5", type, srcElement);
      }
      else {
        updateCodeDigitEntry("codeEntry6", type, srcElement);
      }

      // The code verification consisting of the code-digit entries
      this.code = [
        this.codeEntry1, 
        this.codeEntry2, 
        this.codeEntry3, 
        this.codeEntry4, 
        this.codeEntry5, 
        this.codeEntry6,
      ].join("");
    },
    submit() {
      this.busy = true
      axios
        .post("/api/user/email/verify", {
          username: this.email,
          code: this.code,
        })
        .then((response) => {
          //console.log(response);
          this.verified = true;
          this.isCodeResent = true;
          this.successMessage = "Verification Successful! You will now be redirected to the Login page";

          // After successfully submitting the code for email verification, the user is redirected to the login page
          setTimeout(() => this.$router.push("login"), 3000);
        })
        .catch((error) => {
          const { data } = error.response;
          this.resendCodeErrorMsg = data;
          this.hasResponseError = true;
          console.error(error.response)
        })
        .finally(() => {
          this.busy = false
        })
    },
    sendEmailVerificationCode() {
      if(this.isResendCodeLinkInactive || this.verified) {
        return;
      }

      this.hasResponseError = false;

      axios
        .post("/api/user/email/code/resend", {
          username: this.email,
        })
        .then((response) => {
          if(response.data === "ok") {
            this.successMessage = `Email Verification code is sent to ${this.email}.`;
            this.isCodeResent = true;
            this.startCountDownTimer();
          }
          else {
            throw new Error("Something went wrong...");
          }
        })
        .catch((error) => {
          if(error.response) {
            // THIS ERROR MESSAGE IS COMING FROM THE BACKEND
            const { message } = error.response.data;
            this.resendCodeErrorMsg = message ?? "User email is not provided";
          }
          else {
            this.resendCodeErrorMsg = error.message;
          }

          this.hasResponseError = true;
        });
    },
  },
}
</script>
<style scoped>
.login-form {
  top: 0 !important;
  padding-top: 88px !important;
  padding-bottom: 12px !important;
}
.login-container {
  background-image: url('../assets/images/HomepageBannerHeader.png');
  background-position: center center;
  background-size: cover;
}

.desktop-content .content {
  padding: 40px;
}
.desktop-content .title-defined {
  width: 75%;
  max-width: 460px;
  gap: 30px;
}
.desktop-content .verification-code {
  gap: 20px;
}

.mobile-content .content {
  padding: 20px;
}
.mobile-content .title-defined {
  width: 100%;
  gap: 40px;
}
.mobile-content .verification-code {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
  gap: 15px;
}

.input-entry-class.border-class {
  border-left: 1px dashed #fff;
}
.input-entry-xs-class.border-class {
  border-top: 1px dashed #fff;
}

.input-entry-class .input-code-row, 
.input-entry-md-class .input-code-row, 
.input-entry-sm-class .input-code-row {
  max-width: 725px;
}
.input-entry-xs-class .input-code-row {
  width: 100%;
}

.input-entry-class .input-code-container {
  width: 99px;
}
.input-entry-sm-class .input-code-container {
  width: 85%;
  max-width: 99px;
  min-width: 85px;
}
.input-entry-md-class .input-code-container {
  width: 90px;
} 
.input-entry-xs-class .input-code-container {
  width: 85%;
  max-width: 85px;
  min-width: 50px;
  height: 70px;
}
.input-code-container {
  height: 101px;
}

.text-display {
  color: #FFF;
  font-style: normal;
  font-family: GeomGraphic;
  font-weight: 400;
}
.title-text {
  font-size: clamp(40px, 4vw, 85px);
  line-height: normal;
}
.description-text {
  color: #E6E6E6;
  font-family: Rajdhani;
  font-size: clamp(18px, 1vw, 27px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.verification-text {
  font-family: Rajdhani;
  font-size: clamp(16px, 2vw, 24px);
  font-weight: 700;
  line-height: normal;
}
.resend-code-link {
  font-family: Rajdhani;
  font-size: clamp(14px, 2vw, 18px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: 5px;
  text-underline-position: from-font;
}
.input-code {
  width: 100%;
  height: 100%;
  text-align: center;
  border: 2px solid #ddd;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 5px;
  color: #ffffff;
  font-size: 70px;
  font-weight: 700;
  line-height: normal;
  font-style: normal;
  font-family: Rajdhani;
  outline: none;
}
input.input-code::-webkit-outer-spin-button,
input.input-code::-webkit-inner-spin-button {
  /* Remove input number type spineer for Chrome, Edge, Safari, Opera */
  -webkit-appearance: none;
  margin: 0;
}
input.input-code {
  /* Remove input number type spinner for Firefox */
  -moz-appearance:textfield;
}
.form-fields {
  width: 100%;
  min-width: 370px;
}
.item-btn {
  width: 220px;
  height: 44px;
  padding: 10px 0px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 50px;
  background-color: #424EC4;
}
.item-btn-gap {
  gap: 15px;
}
@media (max-width: 991px) {
  .section {
    padding-top: 88px !important;
  }
}
</style>